import type { NextApiRequest, NextApiResponse } from 'next'
import { useLocaleCredentials as setLocaleCredentials } from 'api'
import { type Language } from 'ecosystem'

export const cancelKlarnaOrderHandler = (
  req: NextApiRequest,
  res: NextApiResponse<{ message: string } | { error: string }>
) => {
  const locale = (req.cookies.NEXT_LOCALE as Language) || 'sv'
  setLocaleCredentials(locale)
  if (req.method !== 'GET') {
    res.status(405).json({ error: 'Method not supported.' })
    return
  }
  // This endpoint is intended to be called from Granditude's backend. If we use this functionality the entire
  // contents of this endpoint should be uncommented.
  // const queryOrderId = req.query.order_id
  //
  // if ( !queryOrderId ) {
  //   return res.status( 400 ).json( { error: 'Missing query params.' } )
  // }
  //
  // const orderId = String( queryOrderId )
  // const { error } = await klarnaApiCall<KlarnaOrder, CreateKlarnaOrderPayload>( 'cancel', { orderId } )
  //
  // if ( error ) {
  //   return res.status( 400 ).json( { error: error || 'Uknown error' } )
  // }
  res.status(200).json({ message: 'OK' })
}
